
function getMainGraphTip(){
	mainGraphTip = d3.tip().attr('class', 'd3-tip').html(function(d){
		var layerToUse = 'all';
		
		if(mainGraphFilter != 'compare-star' && (graphType != 'Pie' || graphType != 'Doughnut')){
			d.data.value.names[layerToUse] = removeRepeatNames(d.data.value.names);
		}

		var html = '';
		if(mainGraphFilter != 'rawreadmission' && mainGraphFilter != 'riskadjusted' && mainGraphFilter != 'lengthofstay' && mainGraphFilter != 'lengthofstaytotal' && mainGraphFilter != 'census' && mainGraphFilter != 'deficiencies' && mainGraphFilter != 'surveys' && mainGraphFilter != 'qis' && mainGraphFilter != 'compare-star'){
			if(d.data.value.names[layerToUse].length > 1){
				html += '<p>Residents:</p>';
			}
			html += '<ul style="'+(d.data.value.names[layerToUse].length == 1 ? 'min-width: 150px;' : '')+'">';
			for(var i = 0; i < d.data.value.names[layerToUse].length; i++){
				html += '<li style="'+(d.data.value.names[layerToUse].length == 1 ? 'float: none; width: auto;' : '')+'">'+d.data.value.names[layerToUse][i]['name']+'</li>';
			}
			html += '</ul>';
			return html;
		}else if(mainGraphFilter == 'rawreadmission'){
			return (d.data.value.readmitPercent*100).toFixed(2)+'%';
		}else if(mainGraphFilter == 'riskadjusted'){
			return (d.data.value.riskAdjustPercent*100).toFixed(2)+'%';
		}else if(mainGraphFilter == 'lengthofstay' || mainGraphFilter == 'lengthofstaytotal'){
			return ((graphType == 'Pie' || graphType == 'Doughnut') ? monthFormat(d.data.key) : d.data.value.type)+' '+(losType == 'los' ? 'Total' : 'Average')+': '+d.data.value[losType].toFixed(2)+' days';
		}else if(mainGraphFilter == 'census'){
			if(isWithinMonth){
				if(graphType == 'Pie' || graphType == 'Doughnut'){
					return d.data.value.adc.toFixed(2)+'% of ADC';
				}else{
					return d.data.value.type+': '+d.data.value.adc.toFixed(2)+'% of ADC';
				}
			}else{
				if(graphType == 'Pie' || graphType == 'Doughnut'){
					return d.data.value.adcAverage.toFixed(2)+'% of ADC';
				}else{
					return d.data.value.type+': '+d.data.value.adcAverage.toFixed(2)+'% of ADC';
				}
			}
		}else if(mainGraphFilter == 'deficiencies' || mainGraphFilter == 'surveys' || mainGraphFilter == 'qis'){
			if(mainGraphFilter == 'surveys'){
				html += '<p>'+answerValues[d.data.value.type]+'</p>';
			}
			html += '<p>Indicators:</p>';
			html += '<ul style="'+(d.data.value.tooltip.length == 1 ? 'min-width: 150px;' : '')+'">';
		d.data.value.tooltip = removeRepeatNames(d.data.value.tooltip, false, 'indicator');
			for(var i = 0; i < d.data.value.tooltip.length; i++){
				html += '<li style="float: none; width: auto;">'+d.data.value.tooltip[i].tag+' - '+d.data.value.tooltip[i].indicator+'</li>';
			}
			html += '</ul>';
			return html;
		}else if(mainGraphFilter == 'compare-star'){
			if(graphType != 'Pie' && graphType != 'Doughnut'){
				html += '<p>'+d.data.value.tooltip.name+'</p>';
				html += '<ul>';
				for(var rating in d.data.value.tooltip.ratings){
					html += '<li style="float: none; width: auto;">'+rating+': '+parseFloat(d.data.value.tooltip.ratings[rating]).toFixed(2)+'</li>';
				}
				html += '</ul>';
			}else{
				d.data.value.tooltip.forEach(function(i){
					html += '<p>'+i.name+'</p>';
				});
			}
			return html;
		}
	});
}

function getPieTip(){
	var financialTip = d3.tip().attr('class', 'd3-tip').html(function(d) {
		return d.data.key+': '+d.data.value;
	});
	financialChart.renderlet(function(chart){
		chart.selectAll('g.pie-slice path').call(financialTip);
		chart.selectAll('g.pie-slice path')
			.on('mouseover', financialTip.show)
			.on('mouseleave', financialTip.hide);
	});
}

function getAdmissionsTip(){
	var admissionsTip = d3.tip().attr('class', 'd3-tip').html(function(d){ 
		return d.data.key+': '+d.data.value+' admissions';
	});
	admissionsChart.renderlet(function(chart){
		chart.selectAll('g.pie-slice path').call(admissionsTip);
		chart.selectAll('g.pie-slice path')
			.on('mouseover', admissionsTip.show)
			.on('mouseleave', admissionsTip.hide);
	});
}

function getDischargesTip(){
	var dischargesTip = d3.tip().attr('class', 'd3-tip').html(function(d){ 
		return d.data.key+': '+d.data.value+' discharges';
	});
	dischargesChart.renderlet(function(chart){
		chart.selectAll('g.pie-slice path').call(dischargesTip);
		chart.selectAll('g.pie-slice path')
			.on('mouseover', dischargesTip.show)
			.on('mouseleave', dischargesTip.hide);
	});
}

function getRawReadmissionTip(){
	var rawreadmissionTip = d3.tip().attr('class', 'd3-tip').html(function(d){ 
		return monthFormat(d.data.key)+': '+(d.data.value.readmitPercent * 100).toFixed(2)+'%';
	});
	rawreadmissionChart.renderlet(function(chart){
		try{
			chart.selectAll('g.pie-slice path').filter(":not(.disabled)").call(rawreadmissionTip);
			chart.selectAll('g.pie-slice path').filter(":not(.disabled)")
				.on('mouseover', rawreadmissionTip.show)
				.on('mouseleave', rawreadmissionTip.hide);
		}catch(e){

		}
	});
}

function getRiskAdjustedTip(){
	var riskAdjustedTip = d3.tip().attr('class', 'd3-tip').html(function(d){ 
		return monthFormat(d.data.key)+': '+(d.data.value.riskAdjustPercent * 100).toFixed(2)+'%';
	});
	riskadjustedChart.renderlet(function(chart){
		try{
			chart.selectAll('g.pie-slice path').filter(":not(.disabled)").call(riskAdjustedTip);
			chart.selectAll('g.pie-slice path').filter(":not(.disabled)")
				.on('mouseover', riskAdjustedTip.show)
				.on('mouseleave', riskAdjustedTip.hide);
		}catch(e){
			
		}
	});
}

function getLengthOfStayTip(){
	var lengthofstayTip = d3.tip().attr('class', 'd3-tip').html(function(d){ 
		return d.data.key+': '+d.data.value.avgLOS.toFixed(2)+' average days';
	});
	lengthofstayChart.renderlet(function(chart){
		chart.selectAll('g.pie-slice path').call(lengthofstayTip);
		chart.selectAll('g.pie-slice path')
			.on('mouseover', lengthofstayTip.show)
			.on('mouseleave', lengthofstayTip.hide);
	});
}

function getLengthOfStayTotalTip(){
	var lengthofstaytotalTip = d3.tip().attr('class', 'd3-tip').html(function(d){ 
		return d.data.key+': '+d.data.value.los.toFixed(2)+' total days';
	});
	lengthofstaytotalChart.renderlet(function(chart){
		chart.selectAll('g.pie-slice path').call(lengthofstaytotalTip);
		chart.selectAll('g.pie-slice path')
			.on('mouseover', lengthofstaytotalTip.show)
			.on('mouseleave', lengthofstaytotalTip.hide);
	});
}

function getPhysicianTip(){
	var physicianTip = d3.tip().attr('class', 'd3-tip').html(function(d) {
		return d.data.key+': '+d.data.value;
	});
	physicianChart.renderlet(function(chart){
		chart.selectAll('g.pie-slice path').call(physicianTip);
		chart.selectAll('g.pie-slice path')
			.on('mouseover', physicianTip.show)
			.on('mouseleave', physicianTip.hide);
	});
}

function getOriginTip(){
	var originTip = d3.tip().attr('class', 'd3-tip').html(function(d) {
		return d.data.key+': '+d.data.value;
	});
	originChart.renderlet(function(chart){
		chart.selectAll('g.pie-slice path').call(originTip);
		chart.selectAll('g.pie-slice path')
			.on('mouseover', originTip.show)
			.on('mouseleave', originTip.hide);
	});
}

function getDiagnosisTip(){
	var diagnosisTip = d3.tip().attr('class', 'd3-tip').html(function(d){
		return d.data.value.description+': '+d.data.value.count;
	});
	diagnosisChart.renderlet(function(chart){
		chart.selectAll('g.pie-slice path').call(diagnosisTip);
		chart.selectAll('g.pie-slice path')
			.on('mouseover', diagnosisTip.show)
			.on('mouseleave', diagnosisTip.hide);
	});
}

function getOriginOthersTip(chart){
	var orginOthersTip = d3.tip().attr('class', 'd3-tip').html(function(d) {
		return d.data.key+': '+d.data.value;
	});
	chart.renderlet(function(chart){
		chart.selectAll('g.pie-slice path').call(orginOthersTip);
		chart.selectAll('g.pie-slice path')
			.on('mouseover', orginOthersTip.show)
			.on('mouseleave', orginOthersTip.hide);
	});
}

function getPhysicianOthersTip(chart){
	var physicianTip = d3.tip().attr('class', 'd3-tip').html(function(d) {
		return d.data.key+': '+d.data.value;
	});
	chart.renderlet(function(chart){
		chart.selectAll('g.pie-slice path').call(physicianTip);
		chart.selectAll('g.pie-slice path')
			.on('mouseover', physicianTip.show)
			.on('mouseleave', physicianTip.hide);
	});
}

function getCensusTooltip(){
	var censusTip = d3.tip().attr('class', 'd3-tip').html(function(d) {
		return d.data.key+': '+d.data.value.adc.toFixed(2)+'% of ADC';
	});
	censusChart.renderlet(function(chart){
		chart.selectAll('g.pie-slice path').call(censusTip);
		chart.selectAll('g.pie-slice path')
			.on('mouseover', censusTip.show)
			.on('mouseleave', censusTip.hide);
	});
}

function getDeficienciesTip(){
	var deficienciesTip = d3.tip().attr('class', 'd3-tip').html(function(d){
		return d.data.key+': '+d.value+' of '+totalIndicators+' indicators';
	});
	deficiencyChart.renderlet(function(chart){
		chart.selectAll('g.pie-slice path').call(deficienciesTip);
		chart.selectAll('g.pie-slice path')
			.on('mouseover', deficienciesTip.show)
			.on('mouseleave', deficienciesTip.hide);
	});
}

function getSurveysTip(){
	var numbers = {1: 'One', 2: 'Two', 3: 'Three', 4: 'Four', 5: 'Five'};
	var surveysTip = d3.tip().attr('class', 'd3-tip').html(function(d){
		return answerValues[d.data.key]+': '+d.value+' answers';
	});
	surveyChart.renderlet(function(chart){
		chart.selectAll('g.pie-slice path').call(surveysTip);
		chart.selectAll('g.pie-slice path')
			.on('mouseover', surveysTip.show)
			.on('mouseleave', surveysTip.hide);
	});
}

function getQISTip(){
	var qisTip = d3.tip().attr('class', 'd3-tip').html(function(d){
		return (d.data.key == "1" ? "YES" : "NO")+': '+d.value;
	});
	qisChart.renderlet(function(chart){
		chart.selectAll('g.pie-slice path').call(qisTip);
		chart.selectAll('g.pie-slice path')
			.on('mouseover', qisTip.show)
			.on('mouseleave', qisTip.hide);
	});
}

function getCompareStarTip(){
	var compareStarTip = d3.tip().attr('class', 'd3-tip').html(function(d) {
		return d.data.key+' Stars: '+d.data.value+' Facilities';
	});
	compareStarPie.renderlet(function(chart){
		chart.selectAll('g.pie-slice path').call(compareStarTip);
		chart.selectAll('g.pie-slice path')
			.on('mouseover', compareStarTip.show)
			.on('mouseleave', compareStarTip.hide);
	});
}